import { AxiosInstance, AxiosProgressEvent, AxiosRequestConfig, AxiosResponse } from 'axios';
import { FILE_UPLOAD_STATUS } from 'Components/Importer/sheetjs-helpers';
import { ImporterStateProps } from 'Components/Importer/Importer';
import { Dispatch, SetStateAction } from 'react';
import { createAxios } from './axiosService';

type ApiProps = {
    url: string;
    configData?: any;
};

let axios: AxiosInstance;

export const setAxiosBaseUrl = (apiUrl: string) => {
    axios = createAxios(apiUrl);
};

type PostApiProps = {
    url: string;
    payload: Record<string, any> | FormData;
    isFileUpload?: boolean;
    controller?: AbortController;
    onProgress?: Dispatch<SetStateAction<ImporterStateProps>>;
};

type DeleteApiProps = {
    url: string;
    payload?: Record<string, any>; // Add payload property
};
export const getApi = async ({ url }: ApiProps): Promise<AxiosResponse<any, any>> => {
    const response = await axios.get(url, {
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};

export const postApi = async ({
    url,
    payload,
    isFileUpload = false,
    controller,
    onProgress
}: PostApiProps): Promise<AxiosResponse<any, any>> => {
    const config: AxiosRequestConfig = {};

    if (isFileUpload) {
        config.signal = controller?.signal;
        config.onUploadProgress = (progressEvent: AxiosProgressEvent) => {
            if (progressEvent?.total) {
                const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                onProgress!((prevState) => ({
                    ...prevState,
                    uploadProgress: percentage,
                    fileUploadStatus: FILE_UPLOAD_STATUS.UPLOADING
                }));
            }
        };
    } else {
        config.headers = {
            Accept: 'application/json'
        };
    }
    const response = await axios.post(url, payload, config);
    return response;
};

export const putApi = async ({ url, payload }: PostApiProps): Promise<AxiosResponse<any, any>> => {
    const response = await axios.put(url, payload, {
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};

export const deleteApi = async ({ url, payload }: DeleteApiProps): Promise<AxiosResponse<any, any>> => {
    const response = await axios.delete(url, {
        headers: {
            Accept: 'application/json'
        },
        data: payload // Pass the payload here
    });
    return response;
};
